import { IEventV2, IEventV3 } from '../../../data/entities/event';
import { IEventNote } from '../../../data/entities/event/event-note';
import { IGuestV3 } from '../../../data/entities/event/guest';

export const getTotalPax = (guest: IGuestV3 | null) => {
	return guest
		? (guest.adults || 0) + (guest.children || 0) + (guest.infants || 0)
		: 0;
};

export const getBookingStatusDisplay = (event: IEventV3 | IEventV2): string => {
	// a Booking is considered as in processing until the owner knows about it.
	// unless it was from before we handled emails in-house.
	const beginningOfTime = new Date('2019-12-01');
	const { status, notes } = event;
	const hasOwnerEmails =
		notes &&
		(event.created_at < beginningOfTime ||
			notes.filter(
				(a: IEventNote) =>
					a.note_type === 'email event' &&
					a.content.includes('owner_booking_confirmation')
			).length);
	const isDirect = event.source === 'direct';
	switch (status) {
		case 'booked':
			if (event.cancellation_request)
				return 'Cancellation requested';
			return hasOwnerEmails ? 'Booked' : 'Processing';
		case 'cancelled':
			return hasOwnerEmails ? 'Cancelled' : 'Processing declined';
		case 'failed':
			return isDirect ? 'Abandoned' : 'Provisional';
		case 'transferred':
			return 'Transferred';
		default:
			return 'Provisional';
	}
};

export const sortByCreatedAt = (sortAsc: boolean): any => {
	return (a: any, b: any) => {
		if (sortAsc) {
			return a.created_at > b.created_at ? 1 : -1;
		} else {
			return b.created_at > a.created_at ? 1 : -1;
		}
	};
};
